var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoBarco(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 31.641,
    viewBox: "0 0 54 31.641",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_56993",
    "data-name": "Grupo 56993",
    transform: "translate(43.139 20.039)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_56992",
    "data-name": "Grupo 56992",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_43358",
    "data-name": "Caminho 43358",
    d: "M410.07,296a1.055,1.055,0,1,0,1.055,1.055A1.056,1.056,0,0,0,410.07,296Z",
    transform: "translate(-409.015 -296)",
    fill: "#fff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_56995",
    "data-name": "Grupo 56995"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_56994",
    "data-name": "Grupo 56994",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_43359",
    "data-name": "Caminho 43359",
    d: "M53.778,122.245a1.048,1.048,0,0,0-.83-.425H49.573v-7.383a1.055,1.055,0,0,0-1.055-1.055H23.2a1.055,1.055,0,0,0-1.055,1.055v11.6H20.04V111.484a1.055,1.055,0,0,0-1.055-1.055h-.633v-3.375A1.055,1.055,0,0,0,17.3,106H12.024a1.055,1.055,0,0,0-1.055,1.055v3.375H8.438a1.055,1.055,0,0,0-1.055,1.055v3.164H5.273A1.055,1.055,0,0,0,4.218,115.7v7.383H1.054a1.084,1.084,0,0,0-1.045,1.2L1.7,136.728a1.055,1.055,0,0,0,1.045.913H42.068a10.342,10.342,0,0,0,9.8-7.024c.006-.018.011-.035.016-.053l2.08-7.4A1.046,1.046,0,0,0,53.778,122.245Zm-12.644-6.753h6.328V117.6H41.135Zm0,4.219h6.328v2.109H41.135ZM32.7,115.492h6.328V117.6H32.7Zm0,4.219h6.328v2.109H32.7Zm0,4.219h4.837l-2.109,2.109H32.7Zm-8.438-8.437h6.328V117.6H24.259Zm0,4.219h6.328v2.109H24.259Zm0,4.219h6.328v2.109H24.259Zm-11.18-15.82h3.164v2.32H13.078v-2.32Zm-3.586,4.43H17.93v2.109H9.492Zm-3.164,4.219h11.6v9.281H13.184v-1.9a1.055,1.055,0,0,0-1.055-1.055h-5.8ZM49.86,129.965a8.233,8.233,0,0,1-7.792,5.566H3.663L2.262,125.2h8.813v1.9a1.055,1.055,0,0,0,1.055,1.055H39.974a1.055,1.055,0,1,0,0-2.109H38.407l2.109-2.109H51.556Z",
    transform: "translate(0 -106)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBarco);
export default __webpack_public_path__ + "static/media/ico-barco.61f553f3a28dd512a67acb45945a8570.svg";
export { ForwardRef as ReactComponent };